
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { Route } from 'vue-router';
import DateRange from '@/components/DateRange.vue';
import api from '@/api';
import Util from '@/utils/util';
import moment from 'moment';
import itemMixin from '@/minix/itemMixin';

const { report, swapInPoint } = api;

async function getSwapInItems(): Promise<Array<{ text: string; value: string }>> {
  const {
    data: { data },
  } = (await swapInPoint.itemList()) || {};
  return data.map((m: any) => ({
    text: m.itemName,
    value: m.itemId,
  }));
}

@Component({ components: { DateRange } })
export default class SwapInReport extends Mixins(Vue.extend(itemMixin)) {
  private data = {
    data: [],
    totalPoints: 0,
    totalCount: 0,
    pageSize: 20,
    pageNo: 0,
  };

  private panel = 0;

  private loading = false;

  private swapInItems: Array<{ text: string; value: string }> = [];

  private headers = [
    { text: '換入時間', value: 'createdOn', width: 160 },
    { text: '點數換入ID', value: 'tid', width: 160 },
    { text: '外部ID', value: 'userIdPublic', width: 100 },
    { text: '姓名', value: 'fullName', width: 100 },
    { text: '換入來源', value: 'itemName', width: 100 },
    { text: '換入SP點數量', value: 'pointValue', width: 100 },
    { text: '換入收益', value: 'income', width: 100 },
    { text: '毛利', value: 'profit', width: 100 },
    { text: '毛利率', value: 'profitMargin', width: 100 },
  ];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get totalPoints() {
    return this.data.totalPoints;
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private filter = {
    userIdPublic: this.$route.query.userIdPublic || undefined,
    fullName: this.$route.query.fullName || undefined,
    itemId: this.$route.query.productName || undefined,
    startDate:
      this.$route.query.startDate === undefined
        ? this.getToday()
        : this.$route.query.startDate,
    endDate: this.$route.query.endDate || undefined,
  };

  private pager = {
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private getToday() {
    return moment().format('yyyy-MM-DD');
  }

  private setSwapInItems(items: Array<{ text: string; value: string }>) {
    this.swapInItems = items;
  }

  private async updatePage(page: number) {
    await this.query(page);
  }

  private async query(page: number) {
    this.pager.pageNo = typeof page === 'number' ? page : 1;
    const query = {
      ...this.filter,
      pageSize: `${this.pager.pageSize}`,
      pageNo: `${this.pager.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      userIdPublic: undefined,
      fullName: undefined,
      itemId: undefined,
      startDate: this.getToday(),
      endDate: undefined,
    };
    await this.query(1);
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async exportCsv() {
    this.loading = true;
    const filter = { ...this.filter };
    const { status, data } = await report.exportSwapIn(filter);
    this.loading = false;
    if (status === 0) return;
    Util.saveFile(data, '會員換入點數.txt');
  }

  private async requestData() {
    this.loading = true;
    const filter = { ...this.filter, ...this.pager };
    const { status, data } = await report.swapIn(filter);
    this.loading = false;
    if (status === 1) {
      this.data = data;
    }
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: SwapInReport) => void) | boolean) => void,
  ) {
    const swapInItems = await getSwapInItems();
    await next(async (vm) => {
      vm.setSwapInItems(swapInItems);
      await vm.requestData();
    });
  }
}
